import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { v4 as uuid } from "uuid";
import { Icon, Pdf } from ".";
import { usePageContext } from "@/comn/features/context/PageContext";
import { useBookmark } from "@/comn/features/config/BookmarkConfig";
import { useMenu } from "@/comn/features/config/MenuConfig";
import { useAuth, useModal, useToast } from "@/comn/hooks";
import classNames from "classnames";
import axios from "axios";
import Cookies from "js-cookie";
import { comnUtils } from "../utils";
import { useTranslation } from "react-i18next";
import { _TEST1234 } from "../features/config/ApiConfig";

type PageNavigationProps = {
    nodes: { path?: string; label: string }[];

    /* deprecated */
    base?: any;
    popup?: any;
};

type PageProps = {
    children?: any;
    pgeUid?: string;
    info?: boolean;
    id?: string;
    title?: string;
    description?: string;
    navigation?: PageNavigationProps;
};

const pause = () => {
    return new Promise<void>((resolve) => {
        setTimeout(() => {
            resolve();
        }, 2000);
    });
};

const BookmarkButton = () => {
    const { root } = useMenu();
    const { isSignedIn } = useAuth();
    const { ref } = usePageContext();
    const { bookmark, addBookmark, removeBookmark } = useBookmark();
    const [isLoading, setIsLoading] = useState(false);

    const { menuId, isPopup } = ref.current;
    const isMarked = bookmark.some((item: any) => item.menuId === menuId);

    let isInSnb = false;
    if (Array.isArray(root?.children)) {
        const _ = (ary: any) => {
            for (const item of ary) {
                if (item.menuId === menuId) {
                    isInSnb = true;
                    return;
                } else if (Array.isArray(item.children)) {
                    _(item.children);
                }
            }
        };
        _(root.children);
    }

    const handleClickBookmark = async () => {
        if (!isLoading) {
            setIsLoading(true);

            // await pause();

            if (isMarked) {
                await removeBookmark(menuId);
            } else {
                await addBookmark(menuId);
            }

            setIsLoading(false);
        }
    };

    if (isPopup || !isSignedIn || !isInSnb) return null;

    return (
        <button className="page-bookmark h-[32px]" disabled={isLoading} onClick={handleClickBookmark}>
            <Icon
                className={classNames("text-primary", isLoading && "animate-pulse")}
                icon={isMarked ? "star_fill" : "star"}
            />
        </button>
    );
};

export const Page = (props: PageProps) => {
    const { children, info, pgeUid, id, title, description, navigation } = props;

    const modal = useModal();
    const toast = useToast();

    const { t } = useTranslation();
    const $$ = useRef(uuid()).current;
    const { ref } = usePageContext();
    const { isPopup, pages, data } = ref.current;

    // console.log(ref);

    const { menuNm, scrnDefnDocId, pathList } = (pgeUid && pages[pgeUid]?.data) || data || {};

    const _title = title || menuNm || false;
    const _id = id || scrnDefnDocId || false;
    const _description = description || false;
    const _breadcrumb = navigation?.nodes || pathList || false;

    const [manual, setManual] = useState<boolean>(false);

    const checkManual = async () => {
        try {
            const lang = "EN";
            const id = String(_id || "")
                .toLocaleLowerCase()
                .replaceAll("-", "")
                .substring(2);
            let sys = "",
                base = "/api/v1/ptl/comn/comn/manl/id/";
            switch (process.env.REACT_APP_SYSTEM_GROUP) {
                case "tancis":
                    sys = process.env.REACT_APP_API_PTLI || "";
                    break;
                case "tanoga":
                case "tanesw":
                case "tancis":
                    sys = process.env.REACT_APP_API_PTLE || "";
                    break;
            }

            const headers: any = { "Accept-Language": lang };
            if (_TEST1234.AUTHORIZATION) {
                headers.Authorization = "Bearer " + _TEST1234.AUTHORIZATION;
            }
            if (_TEST1234.REFRESH_AUTHORIZATION) {
                headers.RefreshAuthorization = "Bearer " + _TEST1234.REFRESH_AUTHORIZATION;
            }

            const url = sys + base + id + "/" + lang;
            const {
                data: {
                    manlFileInfo: { content },
                },
            } = await axios.get(url, {
                headers,
            });

            if (content !== null && content.fileUuid !== null) {
                setManual(true);
            }
        } catch (error: any) {
            console.log(error);
        }
    };

    const handleClickManual = async () => {
        try {
            const lang = "EN";
            const id = String(_id || "")
                .toLocaleLowerCase()
                .replaceAll("-", "")
                .substring(2);
            let sys = "",
                base = "/api/v1/ptl/comn/comn/manl/id/";
            switch (process.env.REACT_APP_SYSTEM_GROUP) {
                case "tancis":
                    sys = process.env.REACT_APP_API_PTLI || "";
                    break;
                case "tanoga":
                case "tanesw":
                case "tancis":
                    sys = process.env.REACT_APP_API_PTLE || "";
                    break;
            }

            const headers: any = { "Accept-Language": lang };
            if (_TEST1234.AUTHORIZATION) {
                headers.Authorization = "Bearer " + _TEST1234.AUTHORIZATION;
            }
            if (_TEST1234.REFRESH_AUTHORIZATION) {
                headers.RefreshAuthorization = "Bearer " + _TEST1234.REFRESH_AUTHORIZATION;
            }

            const url = sys + base + id + "/" + lang;
            const {
                data: {
                    manlFileInfo: { content },
                },
            } = await axios.get(url, {
                headers,
            });

            if (content) {
                const data = await comnUtils.getManual(content);
                modal.openModal({
                    type: "pdf",
                    data,
                    thumbnail: true,
                    download: true,
                    print: true,
                    draggable: true,
                });
            }
        } catch (error: any) {
            // 예외처리
            // toast.showToast({ type: "error", content: error?.message || "An error occurred" });
            modal.openModal({ content: t("msg.com.00148") });
        }
    };

    useLayoutEffect(() => {
        const pageHeaders = document.getElementsByClassName("page-header");
        Array.from(pageHeaders)
            .slice(1, pageHeaders.length)
            .forEach((element: any) => {
                if (element.dataset.info !== "true") element.style.display = "none";
            });

        const pageNavigations = document.getElementsByClassName("page-navigation");
        Array.from(pageNavigations)
            .slice(1, pageNavigations.length)
            .forEach((element: any) => {
                element.style.display = "none";
            });

        const pageBookmarks = document.getElementsByClassName("page-bookmark");
        Array.from(pageBookmarks)
            .slice(1, pageBookmarks.length)
            .forEach((element: any) => {
                element.style.display = "none";
            });
    }, []);

    useEffect(() => {
        if (_id) checkManual();
    }, []);

    return (
        <div className="flex flex-col gap-4">
            {info !== false && (_title || _id || _description || _breadcrumb) && (
                <div data-info={info} className="page-header flex items-end justify-between flex-wrap-reverse">
                    <div className="flex items-start gap-1 pr-8">
                        <BookmarkButton />
                        <div>
                            <div className="flex items-center leading-8 text-2xl font-semibold">
                                {_title && _title}
                                {_id && <>&nbsp;({_id})</>}
                                {_id && manual && (
                                    <button onClick={handleClickManual} title={t("L_MANL_DOWN")}>
                                        <Icon icon="question" color="info" size="lg" className="ml-1" />
                                    </button>
                                )}
                            </div>
                            {_description && <p className="text-lg">{_description}</p>}
                        </div>
                    </div>

                    {!isPopup && Array.isArray(_breadcrumb) && Boolean(_breadcrumb.length) && (
                        <ul className="page-navigation flex items-center gap-x-[10px] gap-y-0 flex-wrap">
                            <li>
                                <Icon icon="home" size="sm" className="text-darkgray" />
                            </li>
                            {_breadcrumb.map((node: any, index: any) => {
                                let url = "";
                                let name = "";

                                if (navigation?.nodes) {
                                    url = node.path;
                                    name = node.label;
                                } else if (pathList) {
                                    url = node.menuUrlAddr;
                                    name = node.menuNm;
                                }

                                return (
                                    <li key={"$breadcrumb$" + $$ + name + index} className="flex gap-2 text-sm">
                                        <span>/</span>
                                        {Boolean(url) ? (
                                            <Link to={url} className="text-blue hover:underline">
                                                {name}
                                            </Link>
                                        ) : (
                                            <span className="text-darkgray">{name}</span>
                                        )}
                                    </li>
                                );
                            })}
                        </ul>
                    )}
                </div>
            )}

            {children}
        </div>
    );
};
